import { createSlice } from '@reduxjs/toolkit';
import  * as TYPES  from '../../types';

export const viewrSlice = createSlice({
    name: 'viewr',
    initialState: {
        visible: false,
        activeIndex: 0,
    },
    reducers: {
        handleViwerEvent: (state, action) => {
            console.log("9999: ", action.payload.activeIndex);
            switch(action.payload.visible){
                case TYPES.VIWERSHOW:
                    state.visible = true;
                    state.activeIndex = action.payload.activeIndex;
                    break;
                case TYPES.VIWERSHOW:
                    state.visible = false;
                    state.activeIndex = 0;
                    break;
                default:
                    state.visible = false;
                    state.activeIndex = 0;
            }
        },
        
    }
});